// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  whatsappApiUrl: "https://api.whatsapp.com/send?phone=",
  whatsappAppUrl: "whatsapp://send?phone=",
  instagramUrl: "https://www.instagram.com/vanessalago.pneumo/",
  facebookUrl: "https://www.facebook.com/dravanessa.pneumo",
  curriculoUrl: "http://lattes.cnpq.br/4045931146292664",
  email: "dravanessalago.pneumo@gmail.com",
  firebaseConfig: {
    apiKey: "AIzaSyCvoXWmGI0U4sK38x4ZtkKTCFcQ-pdcHRE",
    authDomain: "consultorio-93e6f.firebaseapp.com",
    projectId: "consultorio-93e6f",
    storageBucket: "consultorio-93e6f.appspot.com",
    messagingSenderId: "973902288619",
    appId: "1:973902288619:web:8fced94c1590e6c13d90ae",
    measurementId: "G-K8NHHF7SML"
  },
  city: "sao-joao-da-boa-vista"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
